import React, { ReactElement } from 'react';
import { Button, Icon, IconNames } from '@dotcom/crown-ui';
import { ActionButtonsProps } from '../contact-types';
import styles from '../contact.module.scss';
import { useFeatureFlags } from '../../../hooks';

export default function ActionButtons({
  contact,
  onEdit,
  onDelete,
  hasTopActionButtons,
}: ActionButtonsProps): ReactElement {
  const { IS_ADDRESS_BULK_UPLOAD_ENABLED: reverseOrder } = useFeatureFlags();

  const handleEdit = () => {
    onEdit(contact);
  };

  const handleDelete = async () => {
    if (onDelete) {
      await onDelete(contact.contact_id);
    }
  };

  return (
    <div
      className={`${styles['address-book-address-actions']} ${hasTopActionButtons ? styles.topActionButtons : ''} ${
        reverseOrder && !hasTopActionButtons ? styles['address-book-address-actions-reverse'] : ''
      }`}
    >
      {onDelete && (
        <Button
          size="icon-sm"
          variant="secondary"
          onClick={handleDelete}
          testId={`delete-contact-${contact.contact_id}`}
          alt-text="delete contact"
          className={styles.action}
        >
          <Icon className={styles.icon} name={IconNames.TrashBold} size="16" color={'dark-gray'} />
        </Button>
      )}
      <Button
        size="icon-sm"
        variant="secondary"
        onClick={handleEdit}
        testId={`edit-contact-${contact.contact_id}`}
        alt-text="edit contact"
        className={styles.action}
      >
        <Icon className={styles.icon} name={IconNames.Edit} size="16" color={'dark-gray'} />
      </Button>
    </div>
  );
}
